// src/pages/Service/Service Entry/serviceThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../../apiservice/apis";
import { getServiceVoucherNoApi } from "../../../../apiservice/service";
import { createServiceEntryPayload } from "../../../../utils/serviceEntry";
import { pathSpliter, formatToCompanyTimezone } from "../../../../lib/functions";
import { getAccountBySeachApi } from "../../../../apiservice/setting";
import { login } from "../../../../services/authServices";

// Fetch service entry number
export const fetchServiceEntryNumber = createAsyncThunk(
  "serviceEntry/fetchServiceEntryNumber",
  async (val) => {
    const res = await getServiceVoucherNoApi({ entryDate: val });
    return res.data;
  }
);

// Fetch service  accs
export const fetchServiceAccs = createAsyncThunk(
  "serviceEntry/fetchServiceAccs",
  async () => {
    const res = await getAccountBySeachApi({
      multiType: ["service_account"],
    });
    return res.data;
  }
);

export const fetchServiceRecord = createAsyncThunk(
  "serviceEntry/fetchServiceRecord",
  async ({location}, { rejectWithValue }) => {
    try {
      console.log(location, "location12wef");
      console.log(
        pathSpliter(location.pathname, 3),
        typeof pathSpliter(location.pathname, 3),
        "location12weffffffff"
      );
      let url = `/service/get-service-record-with-details`;
      let para = {
        service_id:
          pathSpliter(location.pathname, 3) !== undefined
            ? pathSpliter(location.pathname, 3)
            : 0,
      };
      console.log(para, "para123");

      if (pathSpliter(location.pathname, 2) === "order-to-service" || pathSpliter(location.pathname, 2) === "service-update") {
        // url = `/service/get-service-order-record-with-details`;
        url = `/service/get-service-record-with-details`;
        para = {
          service_o_id:
            pathSpliter(location.pathname, 3) !== undefined
              ? pathSpliter(location.pathname, 3)
              : 0,
        };
      }

      const res = await postData(url, para);
      return res.data[0]; // pass record to slice
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


// Create or Update Service Entry
export const createServiceEntry = createAsyncThunk(
  "serviceEntry/createServiceEntry",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState().serviceEntry;
      const { authInfo } = getState().auth;

      const {
        itemCart,
        payServiceCart,
        selectedServiceAcc,
        selectedDiscountAcc,
        selectedTaxAcc,
        selectedTransportAcc,
        customerInfo,
        footerValues,
        tagFieldId,
      } = state;

      const {
        description: narration,
        subtotal,
        total_discount,
        total_tax,
        grandTotal,
        paidAmount,
        dueAmount,
        serviceCharge,
        discountPct,
        taxPct,
      } = footerValues;

      // 🔹 Validation
      // const convertedTotal = (payServiceCart || []).reduce(
      //   (sum, p) => sum + Number(p.tran_amount || p.amount || 0),
      //   0
      // );

      // const paymentDifference = Math.abs(Number(grandTotal) - convertedTotal);

      // if (itemCart.length === 0) {
      //   return rejectWithValue("Item cart is empty!");
      // }
      // if (!selectedServiceAcc) {
      //   return rejectWithValue("Select Services Account!");
      // }
      // if (!selectedDiscountAcc) {
      //   return rejectWithValue("Discount Account is required!");
      // }
      // if (!selectedTaxAcc) {
      //   return rejectWithValue("VAT Account is required!");
      // }
      // if (!customerInfo?.acc_id) {
      //   return rejectWithValue("Select Customer!");
      // }
      // if (narration && narration.length > 100) {
      //   return rejectWithValue("Description size exceeded!");
      // }
      // if (customerInfo.institution_name && customerInfo.institution_name.length > 100) {
      //   return rejectWithValue("Institution Name size exceeded!");
      // }
      // if (customerInfo.address && customerInfo.address.length > 200) {
      //   return rejectWithValue("Address size exceeded!");
      // }
      // if (!customerInfo.contact_no || customerInfo.contact_no.length <= 0) {
      //   return rejectWithValue("Contact No is required!");
      // }
      // if (
      //   state.conversion_rate
      //     ? paymentDifference > 0.1
      //     : Number(paidAmount) !== convertedTotal
      // ) {
      //   return rejectWithValue(
      //     "Paid Amount & Payment Cart Amount should be same!"
      //   );
      // }



      // 🔹 Build payload using helper
      const payload = createServiceEntryPayload(state, authInfo);

      if (tagFieldId) {
        payload.masterData.tag_feild_id = tagFieldId;
      }

      // 🔹 Call API
      let res;
      if (state.service_id) {
        res = await postData(`/service/update-service`, {
          ...payload,
          service_id: state.service_id,
        });
      } else {
        res = await postData(`/service/create-service`, payload);
      }

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

